
import React from 'react';
import "../css/userCertificate.css";
import i18n from '../I18N/I18n.js'; 
import { Carousel } from 'react-responsive-carousel';
import logovideo from '../img/icono-video.jpg'

const UserCertificateList = ({ tipoArchivo1, tipoArchivo2, tipoArchivo3, pestaniaSeleccionada, changePestania }) => {
  
    // Verificamos si los archivos existen
    const isTipoArchivo1Image = tipoArchivo1 && tipoArchivo1.type === 'image';
    const isTipoArchivo2Image = tipoArchivo2 && tipoArchivo2 !== "" && tipoArchivo2.type === 'image';
    const isTipoArchivo3Image = tipoArchivo3 && tipoArchivo3 !== "" && tipoArchivo3.type === 'image';
    const isTipoArchivo3Video = tipoArchivo3 && tipoArchivo3 !== "" && tipoArchivo3.type === 'video';

    if (isTipoArchivo1Image && isTipoArchivo2Image && isTipoArchivo3Image) {
        return (
            <>
            <div className="tabs">
                    <button className='active-tab'>
                        {i18n.t('fotos')}
                    </button>
                </div>
            <div className="nftDisplay_imgItem_16">
                <Carousel>
                    <div>
                        <img src={tipoArchivo1.url} width="250px" alt="Image1" />
                    </div>
                    <div>
                        <img src={tipoArchivo2.url} width="250px" alt="Image2" />
                    </div>
                    <div>
                        <img src={tipoArchivo3.url} width="250px" alt="Image3" />
                    </div>
                </Carousel>
            </div>
            </>
        );
    } 

    

    if (isTipoArchivo1Image && isTipoArchivo2Image && isTipoArchivo3Video) {
        return (
            <>
            
                <div className="tabs">
                    <button className={pestaniaSeleccionada === 1 ? 'active-tab' : 'tab'}
                            onClick={() => changePestania(1)}>
                        {i18n.t('fotos')}
                    </button>
                    <button className={pestaniaSeleccionada === 2 ? 'active-tab' : 'tab'}
                            onClick={() => changePestania(2)}>
                        {i18n.t('video')}
                    </button>
                </div>

                {pestaniaSeleccionada === 1 && (
                    <div className="nftDisplay_imgItem_16">
                        <Carousel>
                            <div>
                                <img src={tipoArchivo1.url} width="250px" alt="Image1" />
                            </div>
                            <div>
                                <img src={tipoArchivo2.url} width="250px" alt="Image1" />
                            </div>
                        </Carousel>
                    </div>
                )}

                {pestaniaSeleccionada === 2 && (
                    <div className="nftDisplay_imgItem_16">
                        <video width="250px" controls poster={logovideo}>
                            <source src={tipoArchivo3.url} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                )} 
            </>
        );
    }
    if (isTipoArchivo1Image && !isTipoArchivo2Image && isTipoArchivo3Video) {
        return (
            <>
                <div className="tabs">
                    <button className={pestaniaSeleccionada === 1 ? 'active-tab' : 'tab'}
                            onClick={() => changePestania(1)}>
                        {i18n.t('fotos')}
                    </button>
                    <button className={pestaniaSeleccionada === 2 ? 'active-tab' : 'tab'}
                            onClick={() => changePestania(2)}>
                        {i18n.t('video')}
                    </button>
                </div>

                {pestaniaSeleccionada === 1 && (
                    <div className="nftDisplay_imgItem_16">
                        <Carousel>
                            <div>
                                <img src={tipoArchivo1.url} width="250px" alt="Image1" />
                            </div>
                        </Carousel>
                    </div>
                )}

                {pestaniaSeleccionada === 2 && (
                    <div className="nftDisplay_imgItem_16">
                        <video width="250px" controls poster={logovideo}>
                            <source src={tipoArchivo3.url} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                )}
            </>
        );
    }

    if (isTipoArchivo1Image && !isTipoArchivo2Image && !isTipoArchivo3Image && !isTipoArchivo3Video ) {
        return (
            <> 
            <div className="tabs">
            <button className='active-tab'>
                {i18n.t('fotos')}
            </button>
        </div>

            <div className="nftDisplay_imgItem_16">
                <Carousel>
                    <div>
                        <img src={tipoArchivo1.url} width="250px" alt="Image1" />
                    </div>
                    
                </Carousel>
            </div>
            </>
        );
    } 

    if (isTipoArchivo1Image && !isTipoArchivo2Image && isTipoArchivo3Image && !isTipoArchivo3Video ) {
        return (
            <div className="nftDisplay_imgItem_16">
                <Carousel>
                    <div>
                        <img src={tipoArchivo1.url} width="250px" alt="Image1" />
                    </div>
                    <div>
                        <img src={tipoArchivo3.url} width="250px" alt="Image1" />
                    </div>
                    
                </Carousel>
            </div>
        );
    } 





    return null; // En caso de que no haya archivos válidos
};

export default UserCertificateList;









